export const getCandidateDesignation = (
  candidate: any,
  fallback = "Designation not available",
): string => {
  const designation =
    candidate?.designation ||
    candidate?.designation_name ||
    candidate?.current_designation ||
    candidate?.position_name ||
    candidate?.job_title ||
    candidate?.primary_job_match?.designation_name;

  return String(designation || "").trim() || fallback;
};
